import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap";

//Import Breadcrumb

//i18n
import { withTranslation } from "react-i18next";
import { getAllEvents, getAllOrganizer, getBookingByEventId, getForumBySlug } from "api";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import { getAuthUser, getCountryId, getUserRole } from "utils/storage";
import TableContainer from "../../../components/Common/TableContainer";
import moment from "moment";

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const pagination = true;
const paginationPageSize = 500;
const paginationPageSizeSelector = [200, 500, 1000];
const AttendeeReport = props => {
    //meta title
    document.title = "Booking List | EventoX";
    const [eventList, setEventList] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [bookingList, setBookingList] = useState([])
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [directBookings, setDirectBookings] = useState([]);
    const [reports, setReports] = useState([
        // { title: "Total Booking", iconClass: "bx-copy-alt", description: 0 },
        // { title: "Total Ticket Purchased", iconClass: "bx-archive-in", description: 0 },
        // {
        //     title: "Total Revenue",
        //     iconClass: "bx-purchase-tag-alt",
        //     description: 0,
        // },
    ])

    useEffect(() => {
        fetchAll()
    }, [])
    useEffect(() => {
        if (selectedEvent) {
          fetchBookingByEvent(selectedEvent.value, fromDate, toDate);
        }
      }, [fromDate, toDate, selectedEvent]);
    const fetchAll = async () => {
        try {
            const respAllEvent = await getAllEvents();
            const eventOptions = respAllEvent.map((item) => {
                return {
                    value: item.eventId,
                    label: item.eventName
                }
            })
            setEventList(eventOptions);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchBookingByEvent = async (eventId) => {
        const getBookingResp = await getBookingByEventId(eventId)
        const activeBooking = getBookingResp.filter((item) => item.bookingStatus === 'confirmed');
        const filteredBooking = activeBooking.filter((item) => {
            const bookingDate = moment(item.createdAt);
            const from = fromDate ? moment(fromDate).startOf('day') : null;
            const to = toDate ? moment(toDate).endOf('day') : null;
          
            return (!from || bookingDate.isSameOrAfter(from)) &&
                   (!to || bookingDate.isSameOrBefore(to));
          });
          
          const currency = filteredBooking[0]?.currency || "";
        setBookingList(filteredBooking)
        const direct = filteredBooking.filter(item => item.bookedBy === "0");
        setDirectBookings(direct);
        const ticketPurchased = filteredBooking.filter((item) => item.bookedBy === "0")
        const totalRevenue = ticketPurchased.reduce((acc, item) => acc + item.totalTicketAmount, 0)
        setReports([
            { title: "No. of Attendees", iconClass: "bx-copy-alt", description: `${activeBooking.length}` },
            { title: "No. of tickets", iconClass: "bx-archive-in", description: ticketPurchased.length },
            {
                title: "Total Revenue",
                iconClass: "bx-purchase-tag-alt",
                description: `${currency} ${totalRevenue}`,
            },
        ])

        console.log("🚀 ~ fetchBookingByEvent ~ getBookingResp:", getBookingResp)

    }
    const columns = useMemo(
        () => [
            {
                headerName: 'Booking No',
                field: 'bookingNo',
                filter: true
              },
            {
                headerName: 'Name',
                valueGetter: params => {
                    const contact = params.data.bookingObject?.primaryContactDetails || {};
                    return `${contact.firstName || ''} ${contact.lastName || ''}`;
                  },
                filter: true
              },
              {
                headerName: 'Email',
                valueGetter: params => params.data.bookingObject?.primaryContactDetails?.email || '',               
                filter: true
              },
            {
                headerName: 'Phone',
                field: 'Contact.phoneNo',
                filter: true

            },
            
            {
                headerName: 'Ticket Type',
                field: 'TicketType.ticketType',
                filter: true
            },
            {
                headerName: 'Ticket Count',
                valueGetter: params => params.data.bookedBy === "0" ? params.data.totalTicketCount || '' : '',
                filter: true
            },
            {
                headerName: 'Booking Status',
                field: 'bookingStatus',
                filter: true
            },
            {
                headerName: 'Booking Date',
                cellRenderer: params => {
                    return moment(params.data.createdAt).format('DD-MMM-YYYY HH:mm:ss')
                },

            },



        ])
    const sideBar = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
            },
        ],
        defaultToolPanel: 'filters',
    };
const downloadCSV = () => {
    if (directBookings.length > 0) {
        const reportTitles = reports.map(report => report.title);
        const reportValues = reports.map(report => report.description);
        const headers = ['Booking No', 'Name', 'Email', 'Phone', 'Ticket Type', 'Ticket Count', 'Booking Status', 'Booking Date'];
        const csvRows = [];
        csvRows.push(reportTitles.join(','));
        csvRows.push(reportValues.join(','));
        csvRows.push('');
        csvRows.push(headers.join(','));
        bookingList.forEach(row => {
            const values = [
                row.bookingNo,
                row.Contact?.firstName || '',
                row.Contact?.email || '',
                row.Contact?.phoneNo || '',
                row.TicketType?.ticketType || '',
                row.totalTicketCount,
                row.bookingStatus,
                moment(row.createdAt).format('DD-MMM-YYYY HH:mm:ss')
            ];
            csvRows.push(values.join(','));
        });

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'attendee_list.csv';
        a.click();
        URL.revokeObjectURL(url);
    }
};

const downloadPDF = () => {
    if (directBookings.length > 0) {
        const doc = new jsPDF('l', 'mm', 'a4');
        const reportHeaders = reports.map(r => r.title);
        const reportValues = reports.map(r => r.description);

        
        doc.autoTable({
            head: [reportHeaders],
            body: [reportValues],
            startY: 10,
            styles: { fontSize: 10 },
            theme: 'striped',
        });
        const headers = ['Booking No', 'Name', 'Email', 'Phone', 'Ticket Type', 'Ticket Count', 'Booking Status', 'Booking Date'];

        const data = directBookings.map(row => [
            row.bookingNo,
            row.Contact?.firstName || '',
            row.Contact?.email || '',
            row.Contact?.phoneNo || '',
            row.TicketType?.ticketType || '',
            row.totalTicketCount,
            row.bookingStatus,
            moment(row.createdAt).format('DD-MMM-YYYY HH:mm:ss')
        ]);

        doc.autoTable({
            head: [headers],
            body: data,
            startY: 30, // space below the report summary
            styles: { fontSize: 10 },
            theme: 'striped',
        });

        doc.save('attendee_list.pdf');
    
    }
};



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Dashboards")}
                        breadcrumbItem={props.t("Attendee Report")}
                    />

                    <Row>
                        <Col xl="12">
                            <Row>
                                {(reports || [])?.map((report, key) => (
                                    <Col md="4" key={"_col_" + key}>
                                        <Card className="mini-stats-wid">
                                            <CardBody>
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted fw-medium">
                                                            {report.title}
                                                        </p>
                                                        <h4 className="mb-0">{report.description}</h4>
                                                    </div>
                                                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                                                        <span className="avatar-title rounded-circle bg-primary">
                                                            <i className={"bx " + report.iconClass + " font-size-24"}></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="12">

                            <Card>
                                <CardBody>
                                    <Row className="mb-3">
                                      <Col xl="5">
                                        <Select
                                          value={selectedEvent}
                                          placeholder="Select Event"
                                           onChange={(data) => {
                                          setSelectedEvent(data);
                                        fetchBookingByEvent(data.value);  
                                              }}
                                          options={eventList}
                                          width="100%"
                                          className="select2-selection"
                                        />
                                      </Col>
                                      <Col xl="2">
                                    <label>From Date</label>
                                    <input
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    className="form-control"
                                    />
                                </Col>

                                <Col xl="2">
                                    <label>To Date</label>
                                    <input
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    className="form-control"
                                    />
                                </Col>
                                <Col >
                <div className="text-lg-end mt-3 mt-lg-0">
                  <UncontrolledDropdown>
                    <DropdownToggle color="primary" type="button">
                      <i className="bx bx-download me-2"></i> Export <i className="mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem href="#" onClick={downloadCSV}>Export CSV</DropdownItem>
                      <DropdownItem href="#" onClick={downloadPDF}>Export PDF</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
                                    </Row>

                                    <Row>
                                        <div style={{
                                            height: '500px',
                                            width: '100%'
                                        }} className="ag-theme-quartz">
                                            <AgGridReact
                                                columnDefs={columns}
                                                rowData={directBookings}
                                                sideBar={sideBar}
                                                rowGroupPanelShow="always"
                                                pagination={pagination}
                                                paginationPageSize={paginationPageSize}
                                                paginationPageSizeSelector={paginationPageSizeSelector}
                                            />
                                        </div>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};



export default withTranslation()(AttendeeReport);

